const ONE_WAY = 'one-way';
const ROUND_TRIP = 'round-trip';
export { ONE_WAY, ROUND_TRIP };
